@if (baseService.selectedItem$ | async; as selectedBorough) {
  <div class="image">
    <div class="manu-bar">
      <div class="manu-borough">
        @for (manu of boroughList; track manu) {
          <div
            class="manu-option"
          [ngClass]="{
            'manu-selected': selectedBorough.Guid === manu.boroughItem.Guid
          }"
            (click)="boroughSelect(manu.boroughItem)"
            >
            <img class="manu-icon" src="{{ getBoroughIcon(manu.boroughItem) }}" />
            <div class="manu-text">
              <span>{{ manu.boroughItem.Name }}</span>
            </div>
          </div>
        }
      </div>
      <div class="manu-global">
        @for (manu of globalList; track manu) {
          <div
            class="manu-option"
          [ngClass]="{
            'manu-selected': selectedBorough.Guid === manu.globalModule.Guid
          }"
            (click)="boroughSelect(manu.globalModule)"
            >
            <img
              class="manu-icon"
              src="{{ getBoroughIcon(manu.globalModule) }}"
              />
              <div class="manu-text">
                <span>{{ manu.globalModule.Code }}</span>
              </div>
            </div>
          }
        </div>
      </div>
      @if (stage === 'staging') {
        <div class="warningbanner">This Beta is for training purposes only. If you need technical support, please email <a href = "mailto: dc@bbjnyc.com">dc@bbjnyc.com</a> or click Support below.</div>
      }
      @if (
        selectedBorough.Guid !== 'f5960107-e029-11eb-a7b4-ace2d34b68ef' &&
        selectedBorough.Guid !== 'f5960486-e029-11eb-a7b4-ace2d34b68ef'
        ) {
        <div
          class="main-body"
          >
          <div class="row" style="height: 100%; overflow: auto">
            <!-- <div *ngIf="!(baseService.screenSize === ScreenSize.Full && displayCalendar)" class="col-md-4" style="padding-right: 40px; padding-left: 120px"> -->
            @if (!(displayCalendar)) {
              <div class="col-md-4" style="padding-right: 40px; padding-left: 120px">
                <div class="row main-left-section">
                  <div class="col px-4">
                    <div class="sub-title-row">
                      <img
                        class="sub-title-icon"
                        src="{{ getBoroughIcon(selectedBorough) }}"
                        />
                        <div class="sub-title-text">
                          <span>{{ selectedBorough.Name }}</span>
                        </div>
                      </div>
                      @if (displayCalendar) {
                        <div
                          class="application-name"
                        >{{ calendarTitle || calendarApplication?.applicationName }}</div>
                      }
                      @if (showProjectDropDown) {
                        <div
                          style="width: 100%; position: relative"
                          >
                          <div
                            class="projectDropDown w-100 px-4"
                            style="margin-top: 15px; display: flex"
                            (click)="toggleProjectDropDown()"
                            >
                            <span class="pddText">
                              {{
                              selectedProjectName !== ''
                              ? selectedProjectName
                              : 'Select Contract'
                              }}
                            </span>
                            <span class="pddAngleDown ml-auto">
                              <em
                                style="width: 30px; height: 30px"
                                class="icon icon-blue"
                    [ngClass]="
                      pddOpen
                        ? 'icon-action_arrow_up'
                        : 'icon-action_arrow_down'
                    "
                              ></em>
                            </span>
                          </div>
                          <div
                            class="w-100"
                            style="position: absolute; z-index: 55"
                            [ngStyle]="{ display: pddOpen ? 'block' : 'none' }"
                            >
                            @for (project of projectList; track project) {
                              <div
                                class="projectDropDownSelection w-100 px-4"
                                (click)="projectSelect(project.contractItem)"
                                >
                                <span>{{ project.contactName }}</span>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              <div [ngClass]="(displayCalendar) ? 'col-md-12' : 'col-md-8'" [ngStyle]="{ 'padding-left': (baseService.screenSize === ScreenSize.Full && displayCalendar) ? '40px' : '40px'}" style="padding-right: 40px; display: flex; flex-direction: column;">
                <div
                  class="row main-right-section"
                  [ngClass]="{ 'calendar': displayCalendar }"
                  style="flex: 1"
                  >
                  @if (!displayCalendar) {
                    @for (application of applicationList; track application) {
                      <div class="col-lg-3 col-md-4 col-sm-6 col-6 p-2">
                        <div class="row mx-0">
                          <!-- <a
                    href="{{
                      application.url ? application.url : '/error/comingSoon'
                    }}"
                          target="_blank"
                          rel="noopener"
                          class="col cornerBox"
                          > -->
                          <a
                            (click)="openApplication($event, application)"
                            href="javascript:void(0)"
                            rel="noopener"
                            class="col cornerBox"
                            >
                            <div class="applicationBox">
                              <div>
                                <img
                                  class="sub-title-icon"
                                  src="{{ getApplicationIcon(application) }}"
                                  />
                                  <!-- <div [ngClass]="getApplicationIconClass(application)" class="icon icon-xl"></div> -->
                                </div>
                                <div class="applicationTitle">
                                  <span>{{ application.applicationName }}</span>
                                </div>
                                <!-- <div
                                class="px-3 py-2"
                        *ngIf="
                          application.applicationName !== 'Workspace' &&
                          application.role !== ''
                        "
                                >
                                <span class="applicationRole">{{
                                  application.role
                                }}</span>
                              </div> -->
                            </div>
                          </a>
                        </div>
                      </div>
                    }
                  }
                  @if (displayCalendar) {
                    <div class="col-12">
                      @if (baseService.screenSize === ScreenSize.Full) {
                        <div class="col-12">
                          <div class="sub-sub-title-row" style="margin-bottom: 8px;">
                            <img
                              class="sub-sub-title-icon"
                              src="{{ getBoroughIcon(selectedBorough) }}"
                              />
                              <div class="sub-sub-title-text">
                                <span>{{ calendarTitle }} Calendar</span>
                              </div>
                            </div>
                          </div>
                        }
                        <app-calendar (titleChange)="onCalendarTitleChange($event)" [facilityCode]="selectedProjectName" style="width: 100%; padding: 0;" class="col-12"></app-calendar>
                      </div>
                    }
                  </div>
                  <div style="width: 100%; position: relative; height: 95px; flex-shrink: 0;"></div>
                </div>
              </div>
              <div class="foot-row">
                <div class="foot-left-section">
                  <p>
                    © NYC BBJ PROGRAM
                  </p>
                </div>
                <div class="foot-right-section">
                  <div class="labelBox">
                    @for (item of contactList; track item) {
                      <div >{{ item.Name }}</div>
                    }
                  </div>
                  <div class="emailBox">
                    @for (item of contactList; track item) {
                      <div>
                        <a [href]="'mailto:' + item.Email">
                          {{ item.Email }}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          @if (
            selectedBorough.Embed
            ) {
            <div
              class="dashboard"
              >
              <iframe
                [src]="makeUrlSafe(selectedBorough.UrlTemplate)"
                allow="geolocation; microphone; camera"
              ></iframe>
            </div>
          }
        </div>
      }
